var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 30,
    viewBox: "0 0 121 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1855_1175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9675 9.76689V22.954H39.1295V9.76689V9.25841H39.6421H44.2271V6.87427H30.8555V9.25841H35.4548H35.9675V9.76689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0112 20.5842H65.1779H64.6653V20.0709V16.6219V16.1086H65.1779H70.9223V13.71H65.1779H64.6653V13.1968V9.74767V9.23438H65.1779H73.0112V6.83105H61.5176V22.9732H73.0112V20.5842Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1623 15.9695L77.3761 6.87427H74.123L82.6271 22.7669L91.1694 6.87427H87.8684L83.0678 15.9695L82.6127 16.8282L82.1623 15.9695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2043 20.0709V16.6219V16.1086H96.717H102.461V13.71H96.717H96.2043V13.1968V9.74767V9.23438H96.717H104.545V6.83105H93.0566V22.9732H104.545V20.5842H96.717H96.2043V20.0709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.909 14.9045L115.11 14.6119L120.5 6.87427H116.955L113.558 11.7385L113.136 12.3381L112.72 11.7385L109.328 6.87427H105.787L111.148 14.6119L111.354 14.9045L111.148 15.1972L105.782 22.9444L109.328 22.954L112.715 18.0706L113.136 17.4662L113.558 18.0706L116.96 22.954H120.5L115.11 15.1972L114.909 14.9045Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5144 16.7802C56.6259 16.4204 57.1098 16.1134 57.771 15.3507C58.5711 14.42 58.9591 13.4654 58.9591 12.4293V11.9831C58.9591 10.3042 58.3459 9.48866 57.1386 8.49567C55.8546 7.44991 54.0388 6.87427 52.0314 6.87427H45.7695L45.7839 22.954H48.9316V15.0005H48.9172V9.25361H51.7726C52.9512 9.25361 54.0579 9.55582 54.6664 10.0451H54.676L54.6808 10.0547C55.3467 10.6304 55.6821 11.3115 55.6821 12.0887C55.6821 13.7005 54.2208 15.0101 52.429 15.0101H50.527V15.0005H49.3867L49.8467 15.5809L55.6533 22.9492H59.4526L55.2701 17.5813L54.8197 17.0057L55.5144 16.7802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9279 20.2388H14.2354V29.8041L27.9615 16.0605C23.4245 15.4945 19.3186 15.2498 15.6918 15.2067L16.9279 20.234V20.2388Z",
    fill: "#EAA03D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 13.7532C3.23566 14.2473 7.4134 14.7893 12.8608 14.8853L12.9278 14.6166C12.1038 14.1561 11.5432 13.2735 11.5432 12.2613C11.5432 10.7742 12.7506 9.56534 14.2358 9.56534V0",
    fill: "#EAA03D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2359 29.8089V20.2436H11.5433L12.7794 15.2258C7.53804 15.3218 3.48007 15.8351 0.758789 16.3148L9.59338 19.5624L14.2406 29.8137L14.2359 29.8089Z",
    fill: "#D86748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9279 12.2661C16.9279 13.2783 16.3721 14.1609 15.5433 14.6214L15.6104 14.8997C19.3282 14.8613 23.549 14.607 28.2251 14.0122L18.8778 10.2513L14.2354 0V9.57013C15.7206 9.57013 16.9279 10.779 16.9279 12.2661Z",
    fill: "#D86748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2298 14.0122L14.2354 0L18.8826 10.2513L28.2298 14.0122Z",
    fill: "url(#paint0_linear_1855_1175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2298 14.0122L14.2354 0L18.8826 10.2513L28.2298 14.0122Z",
    fill: "#E2833D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5885 19.5577L0.753906 16.3101L14.2358 29.809L9.5885 19.5577Z",
    fill: "url(#paint1_linear_1855_1175)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5885 19.5577L0.753906 16.3101L14.2358 29.809L9.5885 19.5577Z",
    fill: "#E2833D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1855_1175",
    x1: 19.2419,
    y1: 15.341,
    x2: 21.3166,
    y2: 6.6643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2833D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EBA449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3BE53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C857"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1855_1175",
    x1: 11.3133,
    y1: 16.0798,
    x2: 7.40579,
    y2: 23.2041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2833D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EBA449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F3BE53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C857"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1855_1175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 29.8089,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.266d920f995577efa52e874fa12bd8b8.svg";
export { ForwardRef as ReactComponent };